<div class="bg-pic w-full h-full" [ngStyle]="{'background': 'url(' + fondoLogin + ')'}" fxLayout="column" fxLayoutAlign="center center">
    <div @fadeInUp class="card overflow-hidden w-full max-w-xs">
        <div class="p-6 pb-0" fxLayout="column" fxLayoutAlign="center center">
            <!-- * Logotipo * -->
            <div class="fill-current text-center">
                <img class="logoLogin" src="assets/img/demo/logo.png">
            </div>
        </div>

        <!-- * Mensaje * -->
        <div class="text-center mt-4">
            <h2 class="title m-0">Bienvenido</h2>
            <h4 class="body-2 text-secondary m-0">Ingrese con sus credenciales.</h4>
        </div>

        <div class="p-6" fxLayout="column" fxLayoutGap="16px">
            <div fxFlex="auto" fxLayout="column">
                <mat-form-field fxFlex="grow">
                    <mat-label>Correo electrónico</mat-label>
                    <input [(ngModel)]="email" matInput required (keyup.enter)="login()">
                </mat-form-field>
                <mat-form-field fxFlex="grow">
                    <mat-label>Contraseña</mat-label>
                    <input [(ngModel)]="password" [type]="inputType" matInput required (keyup.enter)="login()">
                    <button (click)="toggleVisibility()" mat-icon-button matSuffix matTooltip="Toggle Visibility"
                        type="button">
                        <mat-icon *ngIf="visible" [icIcon]="icVisibility"></mat-icon>
                        <mat-icon *ngIf="!visible" [icIcon]="icVisibilityOff"></mat-icon>
                    </button>
                </mat-form-field>
            </div>

            <div fxLayout="row" fxLayoutAlign="space-between center">
                <a [routerLink]="['/login/forgot-password']" class="caption">¿Olvidó su contraseña?</a>
            </div>

            <button (click)="login()" [disabled]="!validForm() || cargando" color="primary" mat-raised-button
                type="button">
                Ingresar
            </button>
            <mat-progress-bar mode="indeterminate" *ngIf="cargando"></mat-progress-bar>
            <div style="text-align: center;">v{{apiURLs.version}}</div>
        </div>
    </div>
</div>